import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import CollegeDistributeSteps from '../CollegeDistributeSteps/CollegeDistributeSteps';
import { moduleActions } from '../../../redux/modules';
import {
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { isSalesforceRep } from '../../../redux/modules/authentication/authentication.module.selectors';
import BalancesAsOfToolTip from '../../Shared/BalancesAsOfToolTip/BalancesAsOfToolTip';
import CollegeBrandingContainer from '../../Shared/CollegeBrandingContainer/CollegeBrandingContainer';
import FullPageLoader from '../../Shared/FullPageLoader/FullPageLoader';
import StepsPageBackground from '../../Shared/StepsPageBackground/StepsPageBackground';
import { appendBasePath } from '../../../utils/nav.utils';
import If from '../../Shared/If/If';
import {
  APP_FAILURE,
  executingCollegeDistributeMessages,
  loadingBuySellCollegeMessages,
  MD529_DECOMMISSION,
  TIMEOUT,
} from '../../../settings/settings';
import { getCollegeTypeCount } from '../../../redux/modules/productTypes/productType.selectors';

export class CollegeDistributeLanding extends Component {
  componentDidUpdate(prevProps) {
    this.checkNeedPushConfirm(prevProps);
  }

  checkNeedPushConfirm(prevProps) {
    const {
      executeRedemption: {
        redemption: { redemptionResultLoading, redemptionResultSuccess },
      },
      history,
    } = this.props;
    const {
      executeRedemption: { redemptionResultLoading: wasLoading },
    } = prevProps;

    if (wasLoading && !redemptionResultLoading && redemptionResultSuccess) {
      history.push(appendBasePath('/college/distribute/confirm'));
    }
  }

  render() {
    const {
      isIFrame,
      customerWebViewEnabled,
      isSalesforceRep,
      applicationData,
      hasMD529OnlyCount,
      executeRedemption: {
        redemption: {
          redemptionResultFailed,
          redemptionResultLoading,
          timeout,
        },
      },
      submitRedemption,
    } = this.props;

    const isLoaderVisible =
      applicationData?.isLoading || redemptionResultLoading;
    const message = applicationData?.isLoading
      ? loadingBuySellCollegeMessages
      : redemptionResultLoading
      ? executingCollegeDistributeMessages
      : '';
    const getError = () => {
      if (applicationData?.hasFailed) {
        return {
          type: APP_FAILURE,
          hasError: true,
        };
      }
      if (timeout) {
        return {
          type: TIMEOUT,
          hasError: true,
        };
      }
      if (redemptionResultFailed) {
        return {
          type: TIMEOUT,
          hasError: true,
        };
      }
      if (hasMD529OnlyCount === 0) {
        return {
          type: MD529_DECOMMISSION,
          hasError: true,
        };
      }
      return {
        type: '',
        hasError: false,
      };
    };
    return (
      <CollegeBrandingContainer>
        <FullPageLoader
          isVisible={isLoaderVisible}
          hasError={getError().hasError}
          errorType={getError().type}
          messages={message}
        />
        <If test={!(isIFrame || (!customerWebViewEnabled && isSalesforceRep))}>
          <StepsPageBackground />
        </If>
        <div className="container">
          <CollegeDistributeSteps submitRedemption={submitRedemption} />
          <BalancesAsOfToolTip />
          <hr />
          <p style={{ margin: '10px 0' }}>2639550</p>
        </div>
      </CollegeBrandingContainer>
    );
  }
}

const mapStateToProps = (state) => {
  const { applicationData, executeRedemption } = state;
  return {
    isIFrame: isEmbeddedInIFrame(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    isSalesforceRep: isSalesforceRep(state),
    applicationData,
    executeRedemption,
    hasMD529OnlyCount: getCollegeTypeCount(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(CollegeDistributeLanding);
